import i18n from '@/i18n'
import { email, number } from './validators'

export default {
  required: (v: string) => !!v || i18n.t('validation.field-required'),
  email: (v: string) => email(v) || i18n.t('validation.email'),
  number: (v: string) => number(v) || i18n.t('validation.must-be-a-number'),
}
